import React, { Component } from 'react';
import axios from 'axios'

class LocationSearch extends Component {
  state = {
    cityName: 'Leeds',
    lat: 53.799722,
    lng: -1.549167,
    countrycode: 'GB',
    defaultURL: `https://api.opencagedata.com/geocode/v1/json?key=${process.env.REACT_APP_GEO_API_KEY}&language=en&pretty=1`,
  }

  render() {
    return (
      <>
        <h3>Enter a location: </h3>
        <form onClick={this.handleSubmitForm}>
          <input
            onChange={this.handleInputChange}
            name="cityName"
            value={this.state.cityName}
          />
          <button>Go!</button>
        </form>
      </>
    );
  }

  getLocation = () => {
    const { cityName, defaultURL } = this.state
    const queries = {
      params: {
        q: cityName,
      }
    }
    axios
      .get(defaultURL, queries)
      .then(({ data }) => {
        this.setState({
          lat: data.results[0].geometry.lat,
          lng: data.results[0].geometry.lng,
          countrycode: data.results[0].components['ISO_3166-1_alpha-2'],
          isLoading: false,
        }, this.props.updateLocation({
          location: cityName,
          coordinates: [this.state.lat, this.state.lng],
          countrycode: this.state.countrycode,
        }))
      })
  }

  handleSubmitForm = (event) => {
    event.preventDefault();
    this.getLocation();
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    })
  }
}

export default LocationSearch;